module.exports = __webpack_public_path__ + "static/media/30.29704f5f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/30.jpg
// module id = 205
// module chunks = 0